import { render, staticRenderFns } from "./Landing2.vue?vue&type=template&id=3e154072"
import script from "./Landing2.vue?vue&type=script&lang=js"
export * from "./Landing2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports